/**
 * This module detects not supported browsers/platforms,
 * prints banner in the console
 */

export class DinosaurDetector {
    constructor() {
        this.ua = navigator.userAgent;
    }

    getMajorVersion(version) {
        if (!version) return 0;
        const major = version.split('.').shift();

        return parseInt(major);
    }

    isIOS() {
        return /iPad|iPhone|iPod/.test(this.ua);
    }

    getIOSVersion() {
        const rxResult = this.ua.match(/OS (\d+)_/);

        return rxResult ? parseInt(rxResult[1]) : -1;
    }

    isChromium() {
        return /Chrome\//.test(this.ua);
    }

    getChromiumVersion() {
        const rxResult = this.ua.match(/Chrome\/([\d.]+)\s/);

        return rxResult ? this.getMajorVersion(rxResult[1]) : -1;
    }

    isFireFox() {
        return /Firefox\//.test(this.ua);
    }

    getFireFoxVersion() {
        const rxResult = this.ua.match(/Firefox\/([\d.]+)/);

        return rxResult ? this.getMajorVersion(rxResult[1]) : -1;
    }

    get isRelic() {
        try {
            if (/MSIE|Trident|Edge/.test(this.ua)) return true; // UA "Edge" is legacy microsoft browser based on Spartan

            if (this.isIOS()) {
                const version = this.getIOSVersion();

                return version < 16;
            }

            // All chromium based browsers
            if (this.isChromium()) {
                return this.getChromiumVersion() < 80;
            }

            if (this.isFireFox()) {
                return this.getFireFoxVersion() < 80;
            }

            return false; // Unknown browser, assume it's modern
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);

            // If we cannot detect the browser, assume it's a dinosaur
            return true;
        }
    }
}

const dinosaurDetector = new DinosaurDetector();

export const isDinosaur = dinosaurDetector.isRelic;

function detect() {
    if (!isDinosaur) {
        return;
    }

    // eslint-disable-next-line no-console
    console.log(
        "%c\n\
                    ██████████████  \n\
                  ████░░████████████\n\
                  ██████████████████\n\
                  ██████████████████\n\
                  ██████████████████\n\
                  ████████          \n\
                  ██████████████░░  \n\
                  ██████            \n\
██              ██████████          \n\
██▒▒        ▒▒▒▒██████████████      \n\
████▓▓      ██████████████  ██      \n\
██████▒▒▒▒████████████████          \n\
██████████████████████████          \n\
██████████████████████              \n\
    ██████████████████              \n\
    ▒▒██████████████                \n\
      ▒▒██████▒▒██▓▓                \n\
        ████      ▓▓                \n\
        ██▒▒      ▓▓                \n\
        ██        ██                \n\
\n\
WOW!,\n\
live dinosaur detected!🦖🦖🦖\n\
\n\
Looks like your browser hasn't\n\
evolved since the Cretaceous period.\n\
\n\
For the best experience, please update\n\
your browser or switch to a modern one.\n\
\n\
Thanks for evolving with us!\n\
",
        'color: green; font-width: bold'
    );
}

detect();
